import React, { Component } from 'react';
import { ComboBox } from './ComboBox';

export class AdminTaskForm extends Component {
    constructor(props) {
        super(props);
        this.state = { loading: true, config: null, task: null }
        this.saveData = this.saveData.bind(this);
    }

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const title = urlParams.get('title');
        const description = urlParams.get('description');
        const process = urlParams.get('process');

        this.setState({ title: title, description, description, process: process });
        this.getData();
    }

    pageIsValid(container) {
        var isValid = true;
        var required = document.querySelectorAll(`#${container} [required]`);
        if (required) {
            required.forEach((e, i) => {
                var val;
                switch (e.type) {
                    case 'select-one':
                        val = e.value;
                        break;
                    case 'email':
                        val = e.value;
                        break;
                    case 'text':
                        val = e.value;
                        break;
                    case 'number':
                        val = e.value;
                        break;
                    case 'checkbox':
                        val = e.checked;
                        break;
                    case 'radio':
                        val = document.querySelectorAll(`input[name=${e.name}]:checked`).length > 0;
                        break;
                    case 'datetime-local':
                        val = e.value;
                        break;
                }

                if (!val) {
                    if (!e.parentElement.querySelector('.error-required')) {
                        var element = document.createElement('span');
                        element.className = 'error-required';
                        element.innerText = 'Este campo es obligatorio.'
                        e.parentElement.append(element)
                    }
                    isValid = false;
                } else if (e.parentElement.querySelector('.error-required')) {
                    e.parentElement.querySelector('.error-required').remove();
                }
            });
        }
        return isValid;
    }

    static renderForm(task, users, e) {
        return (
            <div id="FormTask">
                <div>
                    <h2>Nueva tarea</h2>
                </div>

                <div className="form">
                    <div className="group-control">
                        <label>Titulo</label>
                        <input className="form-control" name="title" required maxLength="255" defaultValue={e.state.title} />
                    </div>
                    <div className="group-control mt-3">
                        <label>Descripci&oacute;n</label>
                        <textarea className="form-control" name="description" maxLength="1000" defaultValue={e.state.description}></textarea>
                    </div>
                    <div className="group-control" hidden>
                        <label>Depende de</label>
                        <ComboBox data={task} id="ComboWrappTask" lot={false}></ComboBox>
                    </div>
                    <div className="group-control mt-3">
                        <label>Sede</label>
                        <select required name="location" className="form-control">
                            <option value="">Seleccione</option>
                            <option value="Medellín">Medellín</option>
                            <option value="Rionegro">Rionegro</option>
                            <option value="Bogotá">Bogotá</option>
                        </select>
                    </div>
                    <div className="group-control mt-3">
                        <label>Proceso</label>
                        <input className="form-control" name="process" required maxLength="50" defaultValue={e.state.process} />
                    </div>
                    <div className="group-control mt-3">
                        <label>Asignar a</label>
                        <ComboBox data={users} id="ComboWrappUsers" lot={true}></ComboBox>
                    </div>
                    <div className="group-control mt-3">
                        <label>¿Cuando debe estar lista?</label>
                        <input type="datetime-local" className="form-control" name="finish" required />
                    </div>
                    <div className="group-control mt-3">
                        <input type="button" className="btn btn-primary" value="Guardar" onClick={e.saveData.bind(this)} />
                        <a href="/tareas" className="btn btn-cancel">Cancelar</a>
                    </div>
                </div>
            </div>
        )
    }

    render() {

        let content = this.state.loading ? <h2>Cargando...</h2> : AdminTaskForm.renderForm(this.state.config.task, this.state.config.users, this);

        return (
            <div>
                {content}
            </div>
        );
    }

    formIsValid = () => {
        let isValid = true;
        var required = document.querySelectorAll('input[required]');
        required.forEach((e, i) => {
            if (!e.value) {
                isValid = false;
                e.setAttribute('style', `${e.getAttribute('style')};border: 1px solid red`)
            }
        });
        return isValid;
    }

    async saveData(e) {

        if (!this.pageIsValid('FormTask'))
            return;

        let parentUsers = [];
        document.querySelectorAll('#ComboWrappUsers ul li input:checked').forEach((e, i) => {
            parentUsers.push({ Id: parseInt(e.value) })
        })

        const model = {
            Title: document.querySelector('input[name=title]').value,
            Description: document.querySelector('textarea[name=description]').value,
            Sede: document.querySelector('select[name=location]').value,
            Process: document.querySelector('input[name=process]').value,
            //IdParent: document.querySelector('select[name=ComboWrappTask]').length > 0 ? parseInt(document.querySelector('select[name=ComboWrappTask]').value) : null,
            TaskFinish: document.querySelector('input[name=finish]').value,
            Users: parentUsers
        };

        this.setState({ loading: true })

        const requestOption = {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify(model)
        };

        const response = await fetch('Task/NewTask', requestOption);

        if (response.status == 200) {
            alert(`La tarea ${model.Title} se ha creado con éxito.`);
            window.location.href = '/tareas';
        }

        const data = await response.json();
        this.setState({ config: data, loading: false })
    }

    async getData() {

        var request = {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `bearer ${localStorage.getItem('token')}`
            }
        }

        const response = await fetch('Task/Get', request);

        if (response.redirected) {
            window.location.href = response.url;
        }

        const data = await response.json();
        this.setState({ config: data, loading: false });
    }
}